import { useEffect, useState } from "react"
import { useLocation, useNavigate } from 'react-router-dom'
import { chargeWalletRequest } from "../core/_requests";
import Swal from 'sweetalert2';
import { detect } from 'detect-browser';
import { useTranslation } from "react-i18next";

const CheckPayment = () => {
    const { t } = useTranslation();

    const location = useLocation();
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [statusMessage, setStatusessage] = useState('');
    const [refId, setRefId] = useState('');
    const browser = detect();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const authority = params.get('Authority') ?? '';
        const status = params.get('Status') ?? '';

        if (authority == '') {
            setMessage(t('PAYMENT.PAYMENT_PROBLEM'))
            setShowMessage(true)
            setStatusessage('error')
        }
        else {
            fetchChargeWallet(authority)
        }
    }, [location.search, t])


    const swalWithRedirect = Swal.mixin({
        didClose: () => {
            if (browser && browser.os) {
                if (browser.os.includes('Android')) {
                    const appUrlScheme = 'airngin://www.airngin.com';
                    window.location.href = appUrlScheme;
                } else if (browser.os.includes('Windows')) {
                    navigate('/payment/chargeWallet')
                } else {
                  
                }
              } else {
                
              }
        }
    });

    useEffect(() => {
        if (showMessage == true) {
            if (statusMessage == 'error') {
                showErrorSwal()
            }
            else if (statusMessage == 'success') {
                showSwal()
            }
        }
    }, [showMessage])

    const showSwal = () => {
        swalWithRedirect.fire({
            title: t('PAYMENT.SUCCESS_TITLE'),
            text: t('PAYMENT.TRANSACTION_NUMBER', { refId }),
            icon: 'success',
            confirmButtonText: t('AUTH.REGISTER_LOGIN.OK')
        });
    }

    const showErrorSwal = () => {
        swalWithRedirect.fire({
            title: message,
            icon: 'error',
            confirmButtonText: t('AUTH.REGISTER_LOGIN.OK')
        });
    }

    const fetchChargeWallet = async (authority) => {
        var chargeWalletRessult = await chargeWalletRequest(authority)
        if (chargeWalletRessult.data?.isSuccess == true) {
            if (chargeWalletRessult.data?.data.returnCode == 100 || chargeWalletRessult.data?.data.returnCode == 100) {
                setRefId(chargeWalletRessult.data?.data.ref_Id)
                setShowMessage(true)
                setStatusessage('success')
            }
            else {
                setMessage(chargeWalletRessult.data?.data.message)
                setShowMessage(true)
                setStatusessage('error')
            }
        }
        else if (chargeWalletRessult.data?.isSuccess == false) {
            if (chargeWalletRessult.data?.data.message != '') {
                setMessage(chargeWalletRessult.data?.data.message)
                setShowMessage(true)
                setStatusessage('error')
            }
            else {
                let message = JSON.parse(chargeWalletRessult.data.message);
                if (message.length >= 1) {
                    let messageShow = message[0].Value.DefaultMessage
                    if (chargeWalletRessult.data.requestId != null) {
                        messageShow = messageShow + '\n ' + t('AUTH.VERIFY.ERROR_CODE') + ' : ' + chargeWalletRessult.data.requestId
                    }
                    //warning
                    if (chargeWalletRessult.data.returnType == 2) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                    //error
                    else if (chargeWalletRessult.data.returnType == 3) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                }
                else {
                    let messageShow = message.Value.DefaultMessage
                    if (chargeWalletRessult.data.requestId != null) {
                        messageShow = messageShow + '\n ' + t('AUTH.VERIFY.ERROR_CODE') + ' : ' + chargeWalletRessult.data.requestId
                    }
                    //warning
                    if (chargeWalletRessult.data.returnType == 2) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                    //error
                    else if (chargeWalletRessult.data.returnType == 3) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                }
            }
        }
        else {
            setMessage(`${t('PAYMENT.STATUS_FETCH_ERROR')} : \n ${chargeWalletRessult}`)
            setShowMessage(true)
            setStatusessage('error')
        }
    }

    return (
        <div className='card mb-5 mb-xl-8'>


        </div>
    )
}

export { CheckPayment }
